import { useAuthorization } from "@sttedra_ui/framework";

import CategoriesView from "../categories/CategoriesView.vue";

export default [
  {
    path: "/admin/Categories",
    name: "Categories",
    component: CategoriesView,
    meta: { title: "Categorías", requiresAuthentication: false },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "admin");

      const { modelRef: authorizationModelRef } = useAuthorization();

      const userRol = authorizationModelRef.value.roles[0];

      if (userRol != "Admin") {
        next({ name: "Login" });
      }

      next();
    },
  },
];
